/**
 * GIFT4TEE — cap nhat so tren icon gio hang cua header tu lam.
 *
 * Header khong phai cua theme ma la custom liquid (sections/header-group.json,
 * block custom_liquid_ecppbq) nen khong co <hdt-cart-count> — thanh phan duy nhat
 * giu con so la:
 *     {% if cart.item_count > 0 %}<span class="gift4tee-cart__badge">N</span>{% endif %}
 * Luu y cai `if`: gio dang rong thi the span KHONG TON TAI san trong trang, phai
 * tu tao ra; va khi gio ve 0 thi xoa han cho giong ban Liquid in ra.
 *
 * File nay khong sua gi trong header-group.json ca — custom liquid o do la mot
 * chuoi JSON dai, chen script vao trong rat de lam hong. Chi bam vao class.
 *
 * Nghe `cart:count:update` (assets/events.js — ThemeEvents.cartCount): su kien
 * chuan cua theme, ca popup (assets/g4t-atc-popup.js) lan cart drawer cua theme
 * deu ban ra sau khi gio doi.
 *
 * Du phong: thay `cart:update` (gio vua doi) ma 400ms sau van khong co
 * `cart:count:update` nao — tuc chuoi cua theme dut o dau do — thi tu goi /cart.js
 * lay so that. Nho vay xoa dong hang trong cart drawer hay sua so luong o trang
 * gio thi badge cung theo dung, khong chi rieng luc bam ADD TO CART.
 */
(function () {
  'use strict';

  var LINK = 'a.gift4tee-cart';
  var BADGE = 'gift4tee-cart__badge';

  function render(count) {
    Array.prototype.forEach.call(document.querySelectorAll(LINK), function (link) {
      var badge = link.querySelector('.' + BADGE);
      if (!(count > 0)) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = BADGE;
        // dat truoc <span>Cart</span> cho dung thu tu nhu ban Liquid; badge la
        // position:absolute nen thu tu khong doi hinh, chi de DOM giong nhau
        link.insertBefore(badge, link.querySelector('span:not(.' + BADGE + ')'));
      }
      badge.textContent = count;
    });
  }

  var pending = null;

  function apply(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    if (pending) {
      clearTimeout(pending);
      pending = null;
    }
    render(count);
  }

  function resync() {
    pending = null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        render(Number(cart.item_count) || 0);
      })
      .catch(function (error) {
        console.error('[g4t-cart-count]', error);
      });
  }

  document.addEventListener('cart:count:update', function (event) {
    apply(event.detail && Number(event.detail.item_count));
  });

  document.addEventListener('cart:update', function () {
    if (pending) clearTimeout(pending);
    pending = setTimeout(resync, 400);
  });
})();
